/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MbiRateChartResponse as ModelsV3LoanManagementMbiRateChartResponse } from '../../models/Models/v3/LoanManagement/mbi-rate-chart-response';

export interface V3LoanManagementLookupsMbiRateChartsGet$Json$Params {
}

export function v3LoanManagementLookupsMbiRateChartsGet$Json(http: HttpClient, rootUrl: string, params?: V3LoanManagementLookupsMbiRateChartsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementLookupsMbiRateChartsGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ModelsV3LoanManagementMbiRateChartResponse>>;
    })
  );
}

v3LoanManagementLookupsMbiRateChartsGet$Json.PATH = '/v3/loan-management/lookups/mbi-rate-charts';
